import { render, staticRenderFns } from "./TipoTributacaoSelect.vue?vue&type=template&id=78896040"
import script from "./TipoTributacaoSelect.vue?vue&type=script&lang=js"
export * from "./TipoTributacaoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports